export const currentUtcMonth = (date = new Date()) => {
  const year = date.getUTCFullYear()
  const month = String(date.getUTCMonth() + 1).padStart(2, '0')
  return `${year}-${month}`
}

/**
 * Normalizes a registration date to the UTC `YYYYMMDD` integer string the backend
 * Unleash context uses (see stpancras-general-api unleash-source.js
 * normalizeRegisteredAt), so the `pricing.experiments.free` `registeredAt NUM_GTE`
 * constraint is evaluated identically on client and server.
 */
export const normalizeRegisteredAt = (value) => {
  let date = value ? new Date(value) : new Date()
  if (Number.isNaN(date.getTime())) date = new Date()
  const yyyymmdd = date.getUTCFullYear() * 10000
    + (date.getUTCMonth() + 1) * 100
    + date.getUTCDate()
  return String(yyyymmdd)
}
